import { Navigate } from 'react-router-dom'

import { links } from 'apps'

interface PrivateRouteProps {
  isLogged: boolean
  navigate?: string
  layout: React.ElementType
  children: React.ReactNode
}

function PrivateRoute({ isLogged, layout: Layout, navigate = links.home.index(), children }: PrivateRouteProps) {
  if (isLogged) {
    return <Layout>{children}</Layout>
  }

  return <Navigate to={navigate} replace />
}

export default PrivateRoute
